// @flow
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'app/common/components/Modal';
import Button from 'app/common/ui/Button';

import styles from './ExOrderChanges.module.scss';;


type Props = {
  disabled: boolean,
  someItemsRemoved: boolean,
  somePricesChanged: boolean,
}

const ExOrderChanges = ({
  disabled,
  someItemsRemoved,
  somePricesChanged,
}: Props) => {
  const { t } = useTranslation('cafeteria');

  const [showMe, setShowMe] = useState(() => ((someItemsRemoved || somePricesChanged) && !disabled));

  useEffect(() => {
    if ((someItemsRemoved || somePricesChanged) && !disabled) {
      setShowMe(true);
    }
  }, [someItemsRemoved, somePricesChanged, disabled]);

  const handleClose = useCallback((e) => {
    e.preventDefault();
    setShowMe(false);
  }, []);


  return (
    <Modal isOpen={showMe}>
      <h2 className={styles.header}>
        {t('order_form_create_order_header', 'Создание заказа')}
      </h2>
      <ul className={styles.text}>

        {someItemsRemoved
          && <li>
            {t(
              'order_form_some_items_removed',
              'Некоторые блюда были удалены из меню и теперь отстутствуют в заказе',
            )}
          </li>}

        {somePricesChanged
          && <li>
            {t(
              'order_form_some_prices_changed',
              'Цена на некоторые блюда изменилась',
            )}
          </li>}

      </ul>
      <div className={styles.buttons}>
        <Button onClick={handleClose}>
          {'Принять'}
        </Button>
      </div>
    </Modal>
  );
};

export default ExOrderChanges;
